import React from 'react';
import List from '@mui/material/List';
import LinearProgress from '@mui/material/LinearProgress';
import PerformRealmBuilder from './RealmBuilder';
import useRetrieveData from 'global/hooks/useRetrieveData';
import { map, filter } from 'global/lib/lodash';

export default function PerformBuilders() {
  const realms = useRetrieveData({ url: '/realms' }, { build: ['realms'], params: { filter: { tier: 'builder' }, include: 'realms' } });
  return (
    <List>
      {realms.data ? (
        map(filter(realms.data, { tier: 'builder' }), (item) => {
          return <PerformRealmBuilder key={item.id} realm={item} />;
        })
      ) : (
        <>
          <LinearProgress />
        </>
      )}
    </List>
  );
}
